import React from "react";
import "./Progress.scss";
import {illustration, techStack} from "../../portfolio";
import {Fade} from "react-reveal";
import Build from "../../assets/lottie/build";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";

export default function StackProgress() {
  if (techStack.viewSkillBars) {
    return (
      <Fade bottom duration={1000} distance="20px">
        <div className="skills-container">
          <div className="capabilities-panel">
            <p className="capabilities-kicker">FOCUS AREAS / APPLIED ENGINEERING</p>
            <h1 className="skills-heading">Engineering capabilities</h1>
            <p className="capabilities-intro">
              Practical ways I turn complex aerospace problems into systems that can be tested, evaluated, and built.
            </p>
            <div className="capability-list">
            {techStack.experience.map((exp, i) => {
              return (
                <article key={i} className="capability-card">
                  <span className="capability-index">0{i + 1}</span>
                  <div>
                    <div className="capability-title-row">
                      <h2>{exp.Stack}</h2>
                      <span className="capability-action">{exp.action}</span>
                    </div>
                    <p>{exp.description}</p>
                  </div>
                  <span className="capability-arrow">↗</span>
                </article>
              );
            })}
            </div>
          </div>

          <div className="skills-image">
            {illustration.animated ? (
              <DisplayLottie animationData={Build} />
            ) : (
              <img
                alt="Skills"
                src={require("../../assets/images/skill.svg")}
              />
            )}
          </div>
        </div>
      </Fade>
    );
  }
  return null;
}
